export default ({
  data: { blockId }
}) => {
  return {
    editorCroppingBlockId: blockId
  }; 
};
